import { useState } from 'react'
import Formsy from 'formsy-react'
import Button from 'shared/components/Button'
import { pendingSelector } from 'api/selectors'
import { signupFlowAddVehicle, setAuthFormState } from 'login-and-signup/actions'
import { AUTH_CONTAINER_STATE_CARDS } from 'login-and-signup/constants'
import Input from 'shared/components/Textfield/withFormsy'
import useCountryState from 'shared/hooks/useCountryState'
import featureToggles from 'shared/featureToggles'
import { getPlateRegex } from 'shared/utils'

const VehiclesContainer = ({ setAuthFormState, signupFlowAddVehicle, pending, translate: t }) => {
    const [canSubmit, setCanSubmit] = useState(false)
    const { countryStateComponent, selectedCountry, selectedState } = useCountryState(true)

    const submit = data => {
        const { licensePlate, make, model, color } = data
        signupFlowAddVehicle(licensePlate, make, model, color, selectedCountry, selectedState)
    }

    const enableSubmit = () => {
        setCanSubmit(true)
    }

    const disableSubmit = () => {
        setCanSubmit(false)
    }

    const skipHandler = () => {
        setAuthFormState(AUTH_CONTAINER_STATE_CARDS)
    }

    return (
        <div className="container header-vehicles-container">
            <Formsy
                className="header-form signup-form"
                onSubmit={submit}
                onValid={enableSubmit}
                onInvalid={disableSubmit}>
                <fieldset>
                    <legend>
                        <T>dashboard.vehicles.add.label</T>
                    </legend>
                    <Input
                        className="form-control header-form-input"
                        name="licensePlate"
                        id="licensePlate"
                        type="text"
                        label={t('dashboard.label.licence.plate')}
                        validationError={t('dashboard.label.licence.plate.invalid')}
                        required
                        validations={{ matchRegexp: getPlateRegex() }}
                    />
                    <Input
                        className="form-control header-form-input"
                        name="make"
                        id="make"
                        type="text"
                        label={t('dashboard.label.vehicle.make')}
                        required
                    />
                    <Input
                        className="form-control header-form-input"
                        name="model"
                        id="model"
                        type="text"
                        label={t('dashboard.vehicles.model.label')}
                        required
                    />

                    <Input
                        className="form-control header-form-input"
                        name="color"
                        id="color"
                        type="text"
                        label={t('dashboard.vehicles.color.label')}
                        required
                    />
                    {featureToggles.caPurchaseFlow && countryStateComponent(true)}
                    <div className="d-flex align-items-end">
                        <Button
                            size="large"
                            className="mt-2"
                            type="submit"
                            isLoading={pending.createVehicle === true}
                            disabled={!canSubmit}>
                            <T>dashboard.vehicles.add.btn.label</T>
                        </Button>
                    </div>
                </fieldset>
                <Button btnStyle="link" size="small" iconRight="next" className="ml-auto mt-3" onClick={skipHandler}>
                    <T>dashboard.vehicles.skip.btn.label</T>
                </Button>
            </Formsy>
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    pending: pendingSelector,
})

export default compose(
    withTranslate,
    connect(mapStateToProps, {
        signupFlowAddVehicle,
        setAuthFormState,
    })
)(VehiclesContainer)
